import React, { type FC, useState, type ReactNode } from "react";
import cn from "classnames";
import { ErrorIcon, InfoIcon, PassIcon, WarningIcon } from "@omega/icons";
import type { NotificationData } from "@app/services/notification";
import "./NotificationToast.scss";

const iconsByType: Record<NotificationData["type"], ReactNode> = {
    error: <ErrorIcon size={20} />,
    warning: <WarningIcon size={20} />,
    success: <PassIcon size={20} />,
    info: <InfoIcon size={20} />,
};

interface NotificationToastProps {
    notification: NotificationData;
    onClose: (id: string) => void;
    onRemove: (id: string) => void;
}

/**
 * Один toast уведомления для мобильного shell.
 */
export const NotificationToast: FC<NotificationToastProps> = ({ notification, onClose, onRemove }) => {
    const [pauseProgress, setPauseProgress] = useState(false);
    const durationMs = notification.duration === "infinite" ? null : notification.duration;

    return (
        <div
            className={cn("app_notification", `app_notification--${notification.type}`, {
                "app_notification--active": notification.open,
            })}
            onClick={() => onClose(notification.id)}
            onMouseEnter={() => setPauseProgress(true)}
            onMouseLeave={() => setPauseProgress(false)}
            onTransitionEnd={() => {
                if (!notification.open) {
                    onRemove(notification.id);
                }
            }}
        >
            <div className="app_notification__body">
                <span className="app_notification__icon">{iconsByType[notification.type]}</span>
                <div
                    className={cn("app_notification__text", {
                        "app_notification__text--dark": notification.type === "warning",
                    })}
                >
                    {notification.message}
                </div>
            </div>
            {durationMs != null && (
                <div
                    className="app_notification__progress"
                    style={{
                        animationDuration: `${durationMs}ms`,
                        animationPlayState: pauseProgress ? "paused" : "running",
                    }}
                    onAnimationEnd={() => onClose(notification.id)}
                />
            )}
        </div>
    );
};
